import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { of } from 'rxjs/observable/of';
import { AuthHttp } from 'angular2-jwt';
import { Http, Headers } from '@angular/http';
import { MarketplaceCase } from '../models/MarketplaceCase';
import { AuthService } from './auth/auth.service';


@Injectable()
export class MarketService {

  myHeader: Headers;

  constructor(private auth: AuthService,
    private authHttp: AuthHttp) {
    this.myHeader = new Headers();
    this.myHeader.append('Content-Type', 'application/json');
    // To fix IE 11 cache API issue.
    this.myHeader.append('Cache-control', 'no-cache');
    this.myHeader.append('Cache-control', 'no-store');
    this.myHeader.append('Expires', '0');
    this.myHeader.append('Pragma', 'no-cache');
    console.log('Question Service Initialized...');
  }

  getMarketInfo() {
    return this.authHttp.get(`/api/MarketPlace/GetMarketInfo`, { headers: this.myHeader }).map(res => {
      if (res.status < 200 || res.status > 300) {
        throw new Error('Get market information request has failed ' + res.status);
      } else {
        // console.log(res.text());
        return res.json();
      }
    }).catch(err => {

      if (err.status === 401 || err.message === 'No JWT present or has expired') {
        this.auth.logOut();
      }

      return Observable.throw(err);
    });
  }

  saveMarketplaceCase(caseInfo: MarketplaceCase) {
    return this.authHttp.post(`/api/MarketPlace/saveMarketplaceCase`, caseInfo, { headers: this.myHeader }).map(res => {
      if (res.status < 200 || res.status > 300) {
        throw new Error('Get market information request has failed ' + res.status);
      } else {
        console.log(res.text());
        return res.json();
      }
    }).catch(err => {

      if (err.status === 401 || err.message === 'No JWT present or has expired') {
        this.auth.logOut();
      }

      return Observable.throw(err);
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/services/market.service.ts